import { useState } from 'react';
import {
    Button,
    Popover,
    List,
    ListItem,
} from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';
import { RemoveCircle, AddCircle } from '@material-ui/icons';
import { EmployeeBidProfileWarningType } from '../../Enums';
import './ImportWarning.scss';

const AddedLineWarning = (props) => (
    <ListItem {...props}>
        <AddCircle style={{ color: 'green', paddingRight: '2px' }} />
        { props.children }
    </ListItem>
);

const RemovedLineWarning = (props) => (
    <ListItem {...props}>
        <RemoveCircle style={{ color: 'red', paddingRight: '2px' }} />
        { props.children }
    </ListItem>
);

/**
 * @typedef {{ warnings: EmployeeBidProfile.IEmployeeBidProfileWarning[], isMini: boolean }} ImportWarningProps
 * @param {ImportWarningProps} props
 */
function ImportWarning(props) {
    const { warnings = [], isMini = false } = props;
    /**
     * @type {[HTMLInputElement | null, Function]}
     */
    const [anchorEl, setAnchorEl] = useState(null);

    /**
     * @param {React.MouseEvent<HTMLButtonElement, MouseEvent>} e
     */
    const handleClick = (e) => {
        setAnchorEl(e.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'import-warnings-popover' : undefined;
    const hasWarnings = !!warnings.length;
    const buttonStyles = isMini ? '' : 'iw-button-container';
    const listStyles = isMini ? 'iw-warnings-list-mini' : '';

    return (
        <div className="iw-container">
            <Button
                onClick={handleClick}
                className={buttonStyles}
                disabled={!hasWarnings}
            >
                <FontAwesomeIcon
                    icon={faExclamationTriangle}
                    size="lg"
                    color={hasWarnings ? '#FFB020' : 'grey'}
                />
                { !isMini && (
                    <span className="iw-label-text">
                        {`${warnings.length} ${warnings.length === 1 ? 'warning' : 'warnings'}`}
                    </span>
                )}
            </Button>
            <Popover
                id={id}
                classes={{
                    paper: 'iw-popover-paper',
                }}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                <List className={listStyles}>
                    {
                        warnings.map((x) => {
                            if (x.type === EmployeeBidProfileWarningType.SchedulePatternAdded) {
                                return (
                                    <AddedLineWarning
                                        key={`${x.type}_${x.details}`}
                                        className="iw-warnings-list-item"
                                    >
                                        <span>The schedule pattern template</span>
                                        <span className="iw-label-schedule-pattern-name">{x.details}</span>
                                        <span>was added</span>
                                    </AddedLineWarning>
                                );
                            }
                            if (x.type === EmployeeBidProfileWarningType.SchedulePatternRemoved) {
                                return (
                                    <RemovedLineWarning
                                        key={`${x.type}_${x.details}`}
                                        className="iw-warnings-list-item"
                                    >
                                        <span>The schedule pattern template</span>
                                        <span className="iw-label-schedule-pattern-name">{x.details}</span>
                                        <span>was removed</span>
                                    </RemovedLineWarning>
                                );
                            }
                            return null;
                        })
                    }
                </List>
            </Popover>
        </div>

    );
}

export default ImportWarning;
